// extracted by mini-css-extract-plugin
export default {"LoadError":"bet_a bhg_qq bhg_a bhg_w bhg_j bhg_q","LoadError__icon":"bet_b bhg_vj bhg_fk bhg_su","LoadError__message":"bet_c bhg_fk bhg_tp"};